exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.center {\n  display: block;\n  margin-left: auto;\n  margin-right: auto;\n  width: 80%;\n}\n", ""]);

// exports
